import { Icon as MaterialIcon } from '@mui/material';
import type { FC } from 'react';

export type IconProps = Omit<React.JSX.IntrinsicElements['svg'], 'className'> & {
  direction?: 'up' | 'right' | 'down' | 'left';
};

const Icon: FC<IconProps> = ({ children, fill = 'currentColor', stroke, ...props }) => (
  <MaterialIcon
    component={() => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill={fill}
        stroke={stroke}
        width={20}
        height={20}
        {...props}
      >
        {children}
      </svg>
    )}
  />
);

export const IconSearch: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Search</title>
    <path
      fill="currentColor"
      d="M2 8c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6Zm17.707 10.293-5.395-5.396C15.4058 11.499 16.0001 9.77505 16 8c0-4.411-3.589-8-8-8S0 3.589 0 8s3.589 8 8 8c1.77495-.0005 3.4987-.5947 4.897-1.688l5.396 5.395c.0927.0932.2028.1671.3241.2176.1214.0505.2515.0764.3829.0764.1314 0 .2615-.0259.3829-.0764.1213-.0505.2314-.1244.3241-.2176.0929-.0928.1667-.203.217-.3243.0503-.1213.0762-.2514.0762-.3827 0-.1313-.0259-.2614-.0762-.3827-.0503-.1213-.1241-.2315-.217-.3243Z"
    />
  </Icon>
);

export const IconCheck: FC<IconProps> = ({ stroke = 'currentColor', ...props }) => (
  <Icon {...props} fill="transparent" stroke={stroke}>
    <title>Check</title>
    <circle cx="10" cy="10" r="7.25" strokeWidth="1.25" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m7.04 10.37 2.42 2.41 3.5-5.56" />
  </Icon>
);

export const IconRemove: FC<IconProps> = (props) => (
  <Icon {...props} fill="transparent" stroke={props.stroke || 'currentColor'}>
    <title>Remove</title>
    <path d="M4 6H16" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.5 9V14" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.5 9V14" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.5 6L6 17H14L14.5 6" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 6L8 5C8 4 8.75 3 10 3C11.25 3 12 4 12 5V6" strokeWidth="1.25" />
  </Icon>
);

export const IconProfile: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Profile</title>
    <path
      fill="currentColor"
      d="M10 9c2.2091 0 4-1.79086 4-4s-1.7909-4-4-4C7.79086 1 6 2.79086 6 5s1.79086 4 4 4Zm-8 7c0 1.6569 1.34315 3 3 3h10c1.6569 0 3-1.3431 3-3s-1.5-5-8-5-8 3.3431-8 5Z"
    />
  </Icon>
);

export const IconCart: FC<IconProps> = (props: IconProps) => (
  <Icon {...props}>
    <title>Cart</title>
    <path
      fill="currentColor"
      d="M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm-6-2c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2Zm6 16H6V8h2v2c0 .55.45 1 1 1s1-.45 1-1V8h4v2c0 .55.45 1 1 1s1-.45 1-1V8h2v12Z"
    />
  </Icon>
);

export const SocialLinkedinIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Linkedin</title>
    <path
      id="Linked-in"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3548 0.964912H22.6452C28.3461 0.964912 32.9677 5.28497 32.9677 10.614V22.193C32.9677 27.522 28.3461 31.8421 22.6452 31.8421H11.3548C5.65383 31.8421 1.03226 27.522 1.03226 22.193V10.614C1.03226 5.28497 5.65383 0.964912 11.3548 0.964912ZM0 10.614C0 4.75207 5.08374 0 11.3548 0H22.6452C28.9162 0 34 4.75207 34 10.614V22.193C34 28.0549 28.9162 32.807 22.6452 32.807H11.3548C5.08374 32.807 0 28.0549 0 22.193V10.614ZM12.7007 12.8429V22.8484H9.39239V12.8429H12.7007ZM11.0055 7.7193C12.0425 7.7193 12.681 8.40104 12.7007 9.29643C12.7007 10.1724 12.0425 10.8738 10.9855 10.8738H10.9658C9.94842 10.8738 9.29032 10.1724 9.29032 9.29643C9.29032 8.40104 9.96812 7.7193 11.0055 7.7193ZM18.098 17.1477V22.8484H14.7727C14.7727 22.8484 14.8206 13.7404 14.7727 12.7826H18.0977L18.0737 14.1207C18.551 13.4241 19.4106 12.4008 21.3689 12.4008C23.7573 12.4008 25.5479 13.8597 25.5479 16.9952V22.8484H22.2173V17.1477C22.2173 15.7757 21.3934 15.0789 20.0798 15.0789C19.0771 15.0789 18.4799 15.7102 18.2175 16.3201C18.1215 16.5376 18.098 16.8426 18.098 17.1477Z"
      fill="currentColor"
    />
  </Icon>
);

export const SocialPhoneIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Phone</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.015.706h7.97c4.024 0 7.286 3.16 7.286 7.059v8.47c0 3.899-3.262 7.06-7.286 7.06h-7.97c-4.024 0-7.286-3.161-7.286-7.06v-8.47c0-3.899 3.262-7.06 7.286-7.06ZM0 7.765C0 3.476 3.589 0 8.015 0h7.97C20.412 0 24 3.476 24 7.765v8.47C24 20.524 20.412 24 15.985 24h-7.97C3.59 24 0 20.524 0 16.235v-8.47Z"
      fill="currentColor"
    />
    <path
      d="M14.824 4.235H9.177c-.974 0-1.765.79-1.765 1.765v12c0 .974.79 1.765 1.765 1.765h5.647c.974 0 1.765-.79 1.765-1.765V6c0-.974-.791-1.765-1.765-1.765ZM12 19.06A1.057 1.057 0 0 1 10.941 18c0-.586.473-1.059 1.06-1.059.585 0 1.058.473 1.058 1.059s-.473 1.059-1.059 1.059Zm3.177-2.824H8.824V6.353h6.353v9.882Z"
      fill="currentColor"
    />
  </Icon>
);

export const SocialEmailIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Email</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.015.706h7.97c4.024 0 7.286 3.16 7.286 7.059v8.47c0 3.899-3.262 7.06-7.286 7.06h-7.97c-4.024 0-7.286-3.161-7.286-7.06v-8.47c0-3.899 3.262-7.06 7.286-7.06ZM0 7.765C0 3.476 3.589 0 8.015 0h7.97C20.412 0 24 3.476 24 7.765v8.47C24 20.524 20.412 24 15.985 24h-7.97C3.59 24 0 20.524 0 16.235v-8.47Z"
      fill="currentColor"
    />
    <path
      d="M17.647 6.353H6.353a1.41 1.41 0 0 0-1.405 1.412l-.007 8.47c0 .777.636 1.412 1.412 1.412h11.294c.777 0 1.412-.635 1.412-1.412v-8.47c0-.777-.635-1.412-1.412-1.412Zm0 9.882H6.353V9.176L12 12.706l5.647-3.53v7.06ZM12 11.295l-5.647-3.53h11.294L12 11.295Z"
      fill="currentColor"
    />
  </Icon>
);

export const ArrowBackIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Back</title>
    <path
      id="back-arrow"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.835 3.8701L16.055 2.1001L6.16504 12.0001L16.065 21.9001L17.835 20.1301L9.70504 12.0001L17.835 3.8701Z"
      fill="currentColor"
    />
  </Icon>
);

export const AddToCartIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Add to Cart</title>
    <path
      d="M14.4379 1.2C14.4379 0.537258 13.9012 0 13.2392 0C12.5771 0 12.0404 0.537258 12.0404 1.2V5.50294L10.4906 3.95147C10.0225 3.48284 9.2635 3.48284 8.79537 3.95147C8.32724 4.4201 8.32724 5.1799 8.79537 5.64853L12.3915 9.24853C12.8597 9.71716 13.6187 9.71716 14.0868 9.24853L17.6829 5.64853C18.1511 5.1799 18.1511 4.4201 17.6829 3.95147C17.2148 3.48284 16.4558 3.48284 15.9877 3.95147L14.4379 5.50294V1.2Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25195 1.2C1.25195 0.537258 1.78864 0 2.45067 0H4.24875C5.24181 0 6.04684 0.805886 6.04684 1.8V12H19.3918L20.4435 4.63029C20.5372 3.97421 21.1443 3.51834 21.7997 3.61206C22.4551 3.70579 22.9105 4.31363 22.8169 4.96971L21.6917 12.8546C21.5651 13.7413 20.8065 14.4 19.9117 14.4H6.04684V16.8H18.034C20.0201 16.8 21.6302 18.4118 21.6302 20.4C21.6302 22.3882 20.0201 24 18.034 24C16.0479 24 14.4379 22.3882 14.4379 20.4C14.4379 19.9792 14.51 19.5753 14.6425 19.2H8.23965C8.37217 19.5753 8.44428 19.9792 8.44428 20.4C8.44428 22.3882 6.83422 24 4.84811 24C2.86201 24 1.25195 22.3882 1.25195 20.4C1.25195 18.8325 2.25265 17.4991 3.64939 17.0048V2.4H2.45067C1.78864 2.4 1.25195 1.86274 1.25195 1.2ZM16.8353 20.4C16.8353 19.7373 17.372 19.2 18.034 19.2C18.6961 19.2 19.2328 19.7373 19.2328 20.4C19.2328 21.0627 18.6961 21.6 18.034 21.6C17.372 21.6 16.8353 21.0627 16.8353 20.4ZM3.64939 20.4C3.64939 19.7373 4.18608 19.2 4.84811 19.2C5.51015 19.2 6.04684 19.7373 6.04684 20.4C6.04684 21.0627 5.51015 21.6 4.84811 21.6C4.18608 21.6 3.64939 21.0627 3.64939 20.4Z"
      fill="currentColor"
    />
  </Icon>
);

export const BellIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Bell Icon</title>
    <path
      d="M12.0403 21.75C13.1391 21.75 14.0382 20.85 14.0382 19.75H10.0424C10.0424 20.85 10.9415 21.75 12.0403 21.75ZM18.0339 15.75V10.75C18.0339 7.68 16.4056 5.11 13.5387 4.43V3.75C13.5387 2.92 12.8694 2.25 12.0403 2.25C11.2112 2.25 10.5419 2.92 10.5419 3.75V4.43C7.68495 5.11 6.0467 7.67 6.0467 10.75V15.75L4.04883 17.75V18.75H20.0318V17.75L18.0339 15.75ZM16.036 16.75H8.04456V10.75C8.04456 8.27 9.55295 6.25 12.0403 6.25C14.5276 6.25 16.036 8.27 16.036 10.75V16.75Z"
      fill="currentColor"
    />
  </Icon>
);

export const CapsulesIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Capsules Icon</title>
    <path
      d="M5.75 14C4.70556 14 3.81944 13.6361 3.09167 12.9083C2.36389 12.1806 2 11.2944 2 10.25C2 9.75 2.09444 9.27222 2.28333 8.81667C2.47222 8.36111 2.74444 7.95556 3.1 7.6L7.6 3.1C7.95556 2.74444 8.36111 2.47222 8.81667 2.28333C9.27222 2.09444 9.75 2 10.25 2C11.2944 2 12.1806 2.36389 12.9083 3.09167C13.6361 3.81944 14 4.70556 14 5.75C14 6.25 13.9056 6.72778 13.7167 7.18333C13.5278 7.63889 13.2556 8.04444 12.9 8.4L8.4 12.9C8.04444 13.2556 7.63889 13.5278 7.18333 13.7167C6.72778 13.9056 6.25 14 5.75 14ZM9.5 10L11.9667 7.46667C12.1889 7.24444 12.3611 6.98333 12.4833 6.68333C12.6056 6.38333 12.6667 6.07222 12.6667 5.75C12.6667 5.08333 12.4306 4.51389 11.9583 4.04167C11.4861 3.56944 10.9167 3.33333 10.25 3.33333C9.92778 3.33333 9.61667 3.39444 9.31667 3.51667C9.01667 3.63889 8.75556 3.81111 8.53333 4.03333L6 6.5L7.6 8.17188L9.5 10Z"
      fill="#E6B3C0"
    />
  </Icon>
);

export const GummieIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Gummie Icon</title>
    <path
      d="M5.47814 11.0631C5.44971 10.6168 5.36443 10.1705 5.27915 9.79391C4.59687 9.65443 4.08517 9.06864 4.08517 8.35733C4.08517 7.54838 4.75323 6.89285 5.57764 6.89285H5.62028C6.23149 7.64601 7.19804 8.12022 8.2641 8.12022C9.33015 8.12022 10.2967 7.63206 10.9221 6.87891H10.9648C11.7892 6.87891 12.4572 7.53443 12.4572 8.34338C12.4572 9.0547 11.9455 9.64048 11.249 9.77996C11.1638 10.1565 11.0927 10.6029 11.05 11.0492C11.8602 11.0631 12.5 11.7186 12.5 12.4997V13.0855C12.5 13.8944 11.8321 14.55 11.0075 14.55C10.3963 14.55 9.85619 14.1734 9.62876 13.6573C8.71906 13.8247 7.76672 13.8247 6.87124 13.6573C6.64381 14.1734 6.10368 14.55 5.49248 14.55C4.66806 14.55 4 13.8944 4 13.0855V12.5136C4.01421 11.7326 4.66806 11.0771 5.47826 11.0631H5.47814Z"
      fill="#C268DB"
    />
    <path
      d="M10.8511 3.69894C10.9932 4.01972 11.0643 4.38236 11.0643 4.75894C11.0643 6.2792 9.81343 7.50657 8.2641 7.50657C6.71476 7.50657 5.46393 6.2792 5.46393 4.75894C5.46393 4.38236 5.535 4.03367 5.67714 3.69894C5.27914 3.47578 5.00908 3.05736 5.00908 2.58315C5.00908 1.87183 5.59185 1.29999 6.31677 1.29999C6.87112 1.29999 7.34018 1.63472 7.53918 2.10894C7.7666 2.05315 8.00824 2.0113 8.2641 2.0113C8.51995 2.0113 8.74737 2.05315 8.98901 2.10894C9.18813 1.63472 9.65707 1.29999 10.2114 1.29999C10.9363 1.29999 11.5191 1.87183 11.5191 2.58315C11.5191 3.0713 11.249 3.47578 10.8511 3.69894Z"
      fill="#C268DB"
    />
  </Icon>
);

export const OilIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Oil Icon</title>
    <path
      d="M7.99999 1.33331C4.44666 4.36665 2.66666 6.98665 2.66666 9.19998C2.66666 12.52 5.19999 14.6666 7.99999 14.6666C10.8 14.6666 13.3333 12.52 13.3333 9.19998C13.3333 6.98665 11.5533 4.36665 7.99999 1.33331ZM5.21999 9.33331C5.46666 9.33331 5.66666 9.50665 5.71332 9.74665C5.98666 11.2266 7.23332 11.7333 8.13999 11.66C8.42666 11.6466 8.66666 11.8733 8.66666 12.16C8.66666 12.4266 8.45332 12.6466 8.18666 12.66C6.76666 12.7466 5.10666 11.9333 4.72666 9.91331C4.67332 9.61331 4.91332 9.33331 5.21999 9.33331Z"
      fill="#F6CA7E"
    />
  </Icon>
);

export const HerbIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Herb Icon</title>
    <path
      d="M10.3267 6.41998C10.2067 4.55998 9.45334 2.74665 8.04 1.33331C6.61334 2.75998 5.82667 4.57331 5.67334 6.41998C6.52667 6.87331 7.31334 7.45998 8 8.17331C8.68667 7.46665 9.47334 6.87998 10.3267 6.41998ZM5.99334 8.18665C5.9 8.11998 5.79334 8.05998 5.69334 7.99331C5.79334 8.06665 5.9 8.11998 5.99334 8.18665ZM8 10.3C6.56667 8.11331 4.12 6.66665 1.33334 6.66665C1.33334 10.2133 3.57334 13.2133 6.68667 14.3266C7.10667 14.48 7.54667 14.5933 8 14.6666C8.45334 14.5866 8.88667 14.4733 9.31334 14.3266C12.4267 13.2133 14.6667 10.2133 14.6667 6.66665C11.88 6.66665 9.43334 8.11331 8 10.3Z"
      fill="#64A570"
    />
  </Icon>
);

export const InhalerIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Inhaler Icon</title>
    <path
      d="M9.66667 11.6666C9.66667 12.7666 8.76667 13.6666 7.66667 13.6666C6.56667 13.6666 5.66667 12.7666 5.66667 11.6666H7C7 12.0333 7.3 12.3333 7.66667 12.3333C8.03334 12.3333 8.33334 12.0333 8.33334 11.6666C8.33334 11.3 8.03334 11 7.66667 11H1.33334V9.66665H7.66667C8.76667 9.66665 9.66667 10.5666 9.66667 11.6666ZM12.6667 4.66665C12.6667 3.37998 11.62 2.33331 10.3333 2.33331C9.04667 2.33331 8 3.37998 8 4.66665H9.33334C9.33334 4.11331 9.78 3.66665 10.3333 3.66665C10.8867 3.66665 11.3333 4.11331 11.3333 4.66665C11.3333 5.21998 10.8867 5.66665 10.3333 5.66665H1.33334V6.99998H10.3333C11.62 6.99998 12.6667 5.95331 12.6667 4.66665ZM12.3333 7.66665H1.33334V8.99998H12.3333C12.8867 8.99998 13.3333 9.44665 13.3333 9.99998C13.3333 10.5533 12.8867 11 12.3333 11V12.3333C13.62 12.3333 14.6667 11.2866 14.6667 9.99998C14.6667 8.71331 13.62 7.66665 12.3333 7.66665Z"
      fill="#0697D6"
    />
  </Icon>
);

export const ExtractIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Extract Icon</title>
    <path
      d="M9.19334 5.33331L10.3933 3.33331L9.19334 1.33331H6.80667L5.60667 3.33331L6.80667 5.33331H9.19334Z"
      fill="#FEBB9B"
    />
    <path
      d="M6.80667 5.99998L5.60667 7.99998L6.80667 9.99998H9.19334L10.3933 7.99998L9.19334 5.99998H6.80667Z"
      fill="#FEBB9B"
    />
    <path
      d="M10.9667 7.67331H13.36L14.5533 5.67331L13.36 3.67331H10.9667L9.76667 5.67331L10.9667 7.67331Z"
      fill="#FEBB9B"
    />
    <path d="M13.36 8.33998H10.9667L9.76667 10.34L10.9667 12.34H13.36L14.5533 10.34L13.36 8.33998Z" fill="#FEBB9B" />
    <path
      d="M5.03334 7.67331L6.23334 5.67331L5.03334 3.67331H2.64L1.44667 5.67331L2.64 7.67331H5.03334Z"
      fill="#FEBB9B"
    />
    <path d="M5.03334 8.33998H2.64L1.44667 10.34L2.64 12.34H5.03334L6.23334 10.34L5.03334 8.33998Z" fill="#FEBB9B" />
    <path
      d="M6.80667 10.6666L5.60667 12.6666L6.80667 14.6666H9.19334L10.3933 12.6666L9.19334 10.6666H6.80667Z"
      fill="#FEBB9B"
    />
  </Icon>
);

export const DeviceIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Device Icon</title>
    <path
      d="M10.4467 2.66665H9.33334V1.33331H6.66667V2.66665H5.55334C5.06667 2.66665 4.66667 3.06665 4.66667 3.55331V13.7733C4.66667 14.2666 5.06667 14.6666 5.55334 14.6666H10.44C10.9333 14.6666 11.3333 14.2666 11.3333 13.78V3.55331C11.3333 3.06665 10.9333 2.66665 10.4467 2.66665ZM7.33334 13.3333V9.66665H6.00001L8.66667 4.66665V8.33331H10L7.33334 13.3333Z"
      fill="#0371E1"
    />
  </Icon>
);

export const TopicalIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Topical Icon</title>
    <path
      d="M7.66667 3.75333V2.33333H9C9.38 2.33333 9.73333 2.44667 10.0333 2.63333L10.9867 1.68C10.4333 1.26 9.75333 1 9 1C8.01333 1 5.33333 1 5.33333 1V2.33333H6.33333V3.76C5.15333 4.00667 4.20667 4.86667 3.84 6H6.49333L10.3333 7.43333V7.02C10.3333 5.40667 9.18667 4.06 7.66667 3.75333ZM1 12L5 13V7H1V12ZM13.6667 11H9L7.60667 10.5133L7.82667 9.88667L9 10.3333H10.88C11.3133 10.3333 11.6667 9.98 11.6667 9.54667C11.6667 9.22 11.46 8.92667 11.1533 8.80667L6.31333 7H5V13.0133L9.66667 14.3333L15 12.3333C14.9933 11.6 14.4067 11 13.6667 11Z"
      fill="#00489D"
    />
    <path
      d="M10.5 3.86364C10.5 3.40545 11.3182 2.5 11.3182 2.5C11.3182 2.5 12.1364 3.40545 12.1364 3.86364C12.1364 4.31636 11.7709 4.68182 11.3182 4.68182C10.8655 4.68182 10.5 4.31636 10.5 3.86364ZM12.6818 8.5C13.4345 8.5 14.0455 7.88909 14.0455 7.13636C14.0455 6.22545 12.6818 4.68182 12.6818 4.68182C12.6818 4.68182 11.3182 6.22545 11.3182 7.13636C11.3182 7.88909 11.9291 8.5 12.6818 8.5Z"
      fill="#00489D"
    />
  </Icon>
);

export const PowderIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Powder Icon</title>
    <path
      d="M14.6667 7.33331H11.8867L14.0467 5.17331L13.1067 4.22665L10 7.33331H8.66666V5.99998L11.7733 2.89331L10.8267 1.95331L8.66666 4.11331V1.33331H7.33333V4.11331L5.17333 1.95331L4.22666 2.89331L7.33333 5.99998V7.33331H6L2.89333 4.22665L1.95333 5.17331L4.11333 7.33331H1.33333V8.66665H4.11333L1.95333 10.8266L2.89333 11.7733L6 8.66665H7.33333V9.99998L4.22666 13.1066L5.17333 14.0466L7.33333 11.8866V14.6666H8.66666V11.8866L10.8267 14.0466L11.7733 13.1066L8.66666 9.99998V8.66665H10L13.1067 11.7733L14.0467 10.8266L11.8867 8.66665H14.6667V7.33331Z"
      fill="#AADAD8"
    />
  </Icon>
);

export const DiscountIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Discount Icon</title>
    <path
      d="M21.8112 0.188784C21.5595 -0.0629279 21.1514 -0.0629279 20.8997 0.188784L19.0224 2.06609C18.9069 2.01109 18.7852 1.96679 18.658 1.93504L12.8241 0.493734C12.169 0.329979 11.4653 0.524843 10.9878 1.00236L0.565417 11.4076C-0.188472 12.1615 -0.188472 13.3883 0.565417 14.1423L7.85779 21.4346C8.61173 22.1885 9.83849 22.1886 10.5925 21.4346L20.9977 11.0122C21.4752 10.5347 21.6701 9.831 21.5063 9.17585L20.065 3.34197C20.0332 3.21487 19.989 3.09305 19.934 2.97764L21.8113 1.10033C22.0629 0.848614 22.0629 0.440495 21.8112 0.188784ZM20.2556 9.48858C20.3102 9.70695 20.2452 9.94147 20.0861 10.1007L9.68083 20.5231C9.42951 20.7744 9.02057 20.7744 8.76925 20.5231L1.47692 13.2307C1.22559 12.9794 1.22559 12.5704 1.47692 12.3191L11.8994 1.9139C12.0213 1.792 12.1874 1.72535 12.3566 1.72535C12.4083 1.72535 12.4604 1.73158 12.5115 1.74434L17.9913 3.09713L16.439 4.64938C15.7204 4.30709 14.8327 4.43265 14.2386 5.02674C13.4846 5.78071 13.4846 7.00743 14.2386 7.7614C14.6155 8.13837 15.1107 8.32687 15.6059 8.32687C16.101 8.32687 16.5962 8.13841 16.9732 7.7614C17.5674 7.16723 17.6929 6.27958 17.3505 5.56092L18.9028 4.00867L20.2556 9.48858ZM16.0617 6.84991C15.8104 7.10119 15.4015 7.10123 15.1501 6.84991C14.8988 6.59862 14.8988 6.18964 15.1501 5.93836C15.2758 5.81268 15.4408 5.7499 15.6059 5.7499C15.7709 5.7499 15.936 5.81272 16.0616 5.93832L16.0616 5.93836L16.0617 5.93841C16.313 6.18969 16.313 6.59862 16.0617 6.84991Z"
      fill="#0171E0"
    />
    <path
      d="M10.5921 7.76125C9.83815 7.00732 8.61138 7.00732 7.85741 7.76125C7.10352 8.51518 7.10352 9.74194 7.85741 10.4959C8.61134 11.2498 9.83815 11.2498 10.5921 10.4959C11.3461 9.74194 11.3461 8.51522 10.5921 7.76125ZM9.68058 9.58433C9.42925 9.83566 9.02032 9.83566 8.76904 9.58433C8.51775 9.33301 8.51767 8.92407 8.76899 8.67279C9.02032 8.42151 9.42921 8.42147 9.68058 8.67279C9.93186 8.92407 9.93186 9.33301 9.68058 9.58433Z"
      fill="#0171E0"
    />
    <path
      d="M11.5042 14.1421C10.7485 13.3864 9.52541 13.3863 8.76958 14.1421C8.01561 14.8961 8.01561 16.1228 8.76958 16.8768C9.52532 17.6325 10.7484 17.6326 11.5042 16.8768C12.2582 16.1228 12.2582 14.8961 11.5042 14.1421ZM10.5927 15.9652C10.3408 16.2171 9.93301 16.2172 9.68112 15.9652C9.42984 15.714 9.42984 15.305 9.68112 15.0537C9.93301 14.8018 10.3408 14.8018 10.5927 15.0537C10.8439 15.305 10.8439 15.7139 10.5927 15.9652Z"
      fill="#0171E0"
    />
    <path
      d="M14.4237 11.7921C14.3844 11.4383 14.0657 11.1833 13.7119 11.2226L5.50804 12.1342C5.15423 12.1735 4.89925 12.4921 4.93857 12.846C4.97522 13.1756 5.25426 13.4195 5.57842 13.4195C5.60218 13.4195 5.62624 13.4181 5.65039 13.4155L13.8543 12.5039C14.2081 12.4646 14.4631 12.1459 14.4237 11.7921Z"
      fill="#0171E0"
    />
  </Icon>
);

export const LoyaltyIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Leafio Loyalty Icon</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.58913 8.56645C8.58913 8.94681 8.29652 9.25882 7.92413 9.28968C7.90394 9.28927 7.88369 9.28906 7.86339 9.28906H2.98823C2.96794 9.28906 2.94768 9.28927 2.92748 9.28968C2.5551 9.25882 2.2625 8.94681 2.2625 8.56645L2.2625 2.96556L7.86339 2.96556C8.2642 2.96556 8.58913 3.29048 8.58913 3.69129V8.56645ZM0.0625 8.56645C0.0625 9.25632 0.301266 9.89042 0.700669 10.3906C0.301266 10.8908 0.0625 11.5249 0.0625 12.2148L0.0624974 19.9771L7.86339 19.9771C8.55316 19.9771 9.18718 19.7384 9.68736 19.3391C10.1882 19.7404 10.8238 19.9805 11.5156 19.9805H19.1608V12.2182C19.1608 11.5267 18.9208 10.8912 18.5197 10.3904C18.9208 9.88965 19.1608 9.25415 19.1608 8.56261V0.761719H11.5156C10.8237 0.761719 10.188 1.00186 9.68708 1.40335C9.18695 1.00417 8.55304 0.765559 7.86339 0.765559L0.0625 0.765559V8.56645ZM2.2625 12.2148C2.2625 11.8344 2.5551 11.5224 2.92749 11.4916C2.94769 11.492 2.96794 11.4922 2.98823 11.4922H7.86339C7.88369 11.4922 7.90394 11.492 7.92415 11.4916C8.29653 11.5224 8.58913 11.8344 8.58913 12.2148L8.58912 17.0513C8.58912 17.4521 8.2642 17.7771 7.86339 17.7771H2.2625L2.2625 12.2148ZM10.7898 3.68745C10.7898 3.28664 11.1148 2.96172 11.5156 2.96172H16.9608V8.56261C16.9608 8.96342 16.6358 9.28835 16.235 9.28835H11.5156C11.1148 9.28835 10.7898 8.96342 10.7898 8.56261V3.68745ZM10.7898 17.0547C10.7898 17.4555 11.1148 17.7805 11.5156 17.7805H16.9608V12.2182C16.9608 11.8174 16.6358 11.4925 16.235 11.4925H11.5156C11.1148 11.4925 10.7898 11.8174 10.7898 12.2182V17.0547Z"
      fill="currentColor"
    />
  </Icon>
);

export const EffervescentIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <title>Effervescent Icon</title>
    <g clipPath="url(#clip0_8790_697)">
      <path
        d="M10.9001 11.145C10.9001 11.0735 10.8919 11.002 10.8797 10.9347C10.716 10.1648 9.60307 9.62622 8.16281 9.62622C7.83138 9.62622 7.48768 9.66409 7.13989 9.71878L7.95822 13.6273C9.64808 13.1477 10.9001 12.0917 10.9001 11.145Z"
        fill="#8A8F3A"
      />
      <path
        d="M7.15632 13.7956L6.33799 9.88705C5.46646 10.1353 4.70132 10.535 4.14895 11.0356C3.58021 11.5531 3.31835 12.1001 3.42064 12.5839C3.58021 13.3496 4.69723 13.8882 6.1375 13.8882C6.46892 13.8882 6.81262 13.8503 7.15632 13.7956Z"
        fill="#8A8F3A"
      />
      <path
        d="M8.51877 5.56199L6.11288 4.7542C3.56378 4.09787 1.52205 4.74579 0.413208 5.26749L1.38293 17.7084C1.44021 18.4404 2.0335 19 2.74545 19H12.2545C12.9664 19 13.5597 18.4404 13.617 17.7084L14.5212 6.1468C14.0752 6.20991 13.527 6.25619 12.8928 6.25619C11.7062 6.25619 10.2168 6.09632 8.51877 5.56199ZM4.39029 5.92382C5.00404 5.92382 5.50322 6.43711 5.50322 7.06819C5.50322 7.69928 5.00404 8.20836 4.39029 8.20836C3.77655 8.20836 3.28146 7.69928 3.28146 7.06819C3.28146 6.43711 3.77655 5.92382 4.39029 5.92382ZM11.0433 14.7843C10.3068 15.4533 9.25527 15.9666 8.08506 16.2232C7.54496 16.3452 7.00486 16.4041 6.48522 16.4041C5.88784 16.4041 5.31501 16.3242 4.81174 16.1643C3.78882 15.8403 3.13825 15.2261 2.97049 14.4351L2.6227 12.7606H2.61861C2.45494 11.9697 2.80683 11.1324 3.6047 10.4046C4.34529 9.7356 5.39275 9.22231 6.56296 8.96567C7.10306 8.84787 7.63907 8.78476 8.1628 8.78476C10.0491 8.78476 11.4279 9.55889 11.6775 10.7538L12.0294 12.4282C12.1931 13.2192 11.8453 14.0565 11.0433 14.7843ZM13.2283 8.20836C13.2283 8.83945 12.7332 9.35274 12.1194 9.35274C11.5057 9.35274 11.0065 8.83945 11.0065 8.20836C11.0065 7.57727 11.5057 7.06819 12.1194 7.06819C12.7332 7.06819 13.2283 7.57727 13.2283 8.20836Z"
        fill="#8A8F3A"
      />
      <path
        d="M11.2152 12.5334C10.5564 13.438 9.30029 14.2037 7.73319 14.5487C7.19718 14.6707 6.65709 14.7296 6.13745 14.7296C5.18818 14.7296 4.36985 14.5319 3.7561 14.1869L3.77247 14.2584C3.87067 14.7381 4.32484 15.1293 5.05316 15.3607C5.8633 15.6174 6.87803 15.63 7.91322 15.4028C8.94841 15.1714 9.86903 14.7296 10.5032 14.1532C11.072 13.6357 11.3298 13.0846 11.2275 12.605L11.2152 12.5334Z"
        fill="#8A8F3A"
      />
      <path
        d="M0 0L0.343699 4.37976C1.6162 3.8244 3.7275 3.27746 6.34206 3.94641L8.76432 4.75841C11.3421 5.56621 13.4206 5.46523 14.5867 5.28432L15 0H0ZM9.24304 3.84544C8.6293 3.84544 8.13011 3.33636 8.13011 2.70527C8.13011 2.07418 8.6293 1.5651 9.24304 1.5651C9.85679 1.5651 10.3519 2.07418 10.3519 2.70527C10.3519 3.33636 9.8527 3.84544 9.24304 3.84544Z"
        fill="#8A8F3A"
      />
    </g>
    <defs>
      <clipPath id="clip0_8790_697">
        <rect width="15" height="19" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const PessaryIcon: FC<IconProps> = (props) => (
  <Icon {...props} viewBox="0 0 10 22">
    <title>Pessary Icon</title>
    <g clipPath="url(#clip0_8790_694)">
      <path
        d="M5.34224 0.15439C5.14469 -0.0521957 4.85531 -0.0521957 4.65776 0.15439C3.53088 1.33331 0 5.2667 0 8.37926C0 11.2825 0.631608 18.8463 0.72621 21.1215C0.742905 21.4795 1.19366 22.0001 1.48581 22.0001H8.33333C8.72009 22.0001 9.2877 21.5126 9.31831 21.0609C9.47691 18.7664 10.0028 11.4946 10 8.37926C10 5.2667 6.4719 1.33331 5.34224 0.15439ZM8.62827 20.7358C8.61158 20.9452 8.46411 21.116 8.25821 21.1655L8.04396 21.2124C7.84363 21.2592 7.65442 21.1022 7.67112 20.8983C7.77963 19.4605 8.12743 14.5217 7.98553 10.6627C7.84641 6.93866 6.60824 3.36611 6.1074 2.18168C6.09071 2.14037 6.14914 2.11282 6.17418 2.14863C6.90874 3.3 8.97329 6.51172 9.19588 7.64932C9.43795 8.88332 8.76461 18.7499 8.62827 20.7358Z"
        fill="#C46B3C"
      />
    </g>
    <defs>
      <clipPath id="clip0_8790_694">
        <rect width="10" height="22" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);
